import { Layout } from "react-grid-layout";

export function isLayoutItemEqual(a: Layout, b: Layout): boolean {
  return a.i === b.i && a.x === b.x && a.y === b.y && a.w === b.w && a.h === b.h;
}

export function isLayoutEqual(a: Layout[], b: Layout[]): boolean {
  if (a.length !== b.length) return false;
  return a.every((aItem) => {
    const bItem = b.find((other) => other.i === aItem.i);
    if (!bItem) return false;
    return isLayoutItemEqual(aItem, bItem);
  });
}
